import angular from 'angular';
import uiRouter from 'angular-ui-router';
import userComponent from './user.component';

import userFormTpl from './templates/form.html';
import userFormLoginTpl from './templates/form.login.html';
import userFormRegisterTpl from './templates/form.register.html';
import userFormForgetTpl from './templates/form.forget.html';
import userFormResetTpl from './templates/form.reset.html';

import userConfirmTpl from './templates/confirm.html';
import userFindTpl from './templates/find.html';

import ybInputGroup from './input-group.directive';
import pwdMask from './pwdMask.directive';

let userModule = angular.module('user', [
    uiRouter
])
    .component('user', userComponent)

    .directive('ybInputGroup', ybInputGroup)

    .directive('pwdMask', pwdMask)

    .name;

let states = [
    {
        name: 'user',
        abstract: true,
        url: '?s&return',
        component: 'user'
    },
    {
        name: 'user.form',
        template: userFormTpl
    },
    {
        name: 'user.form.login',
        url: '/login',
        template: userFormLoginTpl,
        title: 'face-user-text001'
    },
    {
        name: 'user.form.register',
        url: '/register',
        template: userFormRegisterTpl,
        title: 'face-user-text002'
    },
    {
        name: 'user.form.forget',
        url: '/forget',
        template: userFormForgetTpl,
        title: 'face-user-text003'
    },
    {
        name: 'user.form.reset',
        url: '/password/reset',
        template: userFormResetTpl,
        title: 'face-user-text004'
    },
    {
        name: 'user.confirm',
        url: '/register/confirm',
        template: userConfirmTpl,
        title: 'face-user-text005'
    },
    {
        name: 'user.find',
        url: '/forget/find',
        template: userFindTpl,
        title: 'face-user-text006'
    }
];

export default {name: userModule, states: states};



// WEBPACK FOOTER //
// ./src/app/components/face/index/user/user.js